import { useEffect } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { productKeyGetter, ProductsListProps } from 'pages/products/components';
import {
  Product as ProductType,
  ProductDetailsTabsIds,
  PriceGroup,
  GridPricing
} from '@setvi/shared/interfaces';
import { ProductLoader } from 'pages/products/components/products-list/components';
import CenterBox from '@setvi/shared/components/scenter-box';
import { SEmptyState, SInfiniteScroll } from '@setvi/shared/components';
import { Customer } from 'Services/Mongo/Types';
import { MobileProductListCard } from './components';
import { ListLoader } from './components/product-card/list/components';
import { ListContainer } from './styled';

export interface MobileProductsList extends Omit<
  ProductsListProps,
  'selectedCustomer' | 'selectedPriceGroup'
> {
  pricingList: GridPricing[];
  // viewMode: Views;
  filters?: {
    customer?: {
      show: boolean;
      value: Customer;
      onChange: (customer: Customer) => void;
    };
    priceGroup?: {
      show: boolean;
      value: PriceGroup;
      onChange: (priceGroup: PriceGroup) => void;
    };
  };
}

export const mobileGridItemSize = {
  minWidth: 155,
  maxWidth: 170
};

const useStyles = makeStyles(({ spacing }) => ({
  container: {
    width: '100%',
    flexWrap: 'wrap',
    display: 'flex',
    gap: spacing(2)
  },
  gridCardWrapper: {
    display: 'flex',
    ...mobileGridItemSize
  },
  listCardWrapper: {
    width: '100%'
  }
}));

export const MobileProductList = ({
  products,
  feedback,
  filters,
  isLoading,
  searchQuery,
  // viewMode,
  selectedProducts,
  pricingList,
  disableSelect,
  productPricesLoading,
  aiSearchActive,
  statusId,
  config: { grid, priceType },
  openProductDetails,
  onPromotionClick,
  onGetProductPrice,
  fetchMore,
  handleProductSelect,
  modifySelectedProduct
}: MobileProductsList) => {
  const classes = useStyles();

  useEffect(() => {
    const productWithPrice: ProductType[] = selectedProducts
      .map(i => {
        const price = products.find(
          j => productKeyGetter(i) === productKeyGetter(j)
        )?.price;

        return typeof price === 'number' ? { ...i, price } : null;
      })
      .filter(i => !!i);
    productWithPrice.length && modifySelectedProduct?.(productWithPrice);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);

  if (aiSearchActive && isLoading)
    return (
      <ProductLoader
        statusId={statusId}
        containerStyle={{ marginTop: 0, gap: 8 }}
        stepsContainerStyle={{ maxHeight: 'min-content' }}
      />
    );

  if (products.length === 0 && !isLoading) {
    const hasSearchQuery = searchQuery.length > 0;

    let content = {
      image: hasSearchQuery
        ? '/images/no-results.svg'
        : '/images/product-placeholder.svg',
      subTitle: hasSearchQuery
        ? 'No Results Found'
        : 'This category does not contain any products',
      title: !hasSearchQuery && 'No Products Available'
    };

    if (aiSearchActive) {
      content = {
        image: '/images/empty/no-data-found.png',
        title: 'No Products Available',
        subTitle: 'We couldn’t find any products that match your request.'
      };
    }

    return (
      <CenterBox height="100%">
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gridGap={30}>
          <SEmptyState
            title={content?.title}
            imageSrc={content?.image}
            subTitle={content?.subTitle}
          />
          {!!feedback && feedback}
        </Box>
      </CenterBox>
    );
  }

  return (
    <ListContainer>
      {/* {viewMode === Views.LIST_VIEW ? ( */}
      <>
        <SInfiniteScroll
          containerClass={classes.container}
          wrapperClass={classes.listCardWrapper}
          list={products}
          keyGetter={address => address._id}
          fetchMore={fetchMore}
          render={product => {
            const isChecked = selectedProducts.some(
              i => productKeyGetter(i) === productKeyGetter(product)
            );
            return (
              <MobileProductListCard
                product={product}
                priceType={priceType}
                filters={filters}
                gridConfig={{ ...grid, pricing: pricingList }}
                aiSearchActive={aiSearchActive}
                productPricesLoading={productPricesLoading}
                searchQuery={searchQuery}
                checked={isChecked}
                onProductClick={openProductDetails}
                onPromotionClick={onPromotionClick}
                onGetProductPrice={p => onGetProductPrice([p])}
                checkboxDisabled={() => disableSelect && !isChecked}
                onStockClick={i =>
                  openProductDetails(i, ProductDetailsTabsIds.WAREHOUSE)
                }
                handleCheck={(checked, p) => {
                  handleProductSelect(checked, p);
                }}
              />
            );
          }}
        />
        {isLoading && <ListLoader />}
      </>
      {/* ) : (
         <>
           <SInfiniteScroll
             containerClass={classes.container}
             wrapperClass={classes.gridCardWrapper}
             list={products}
             keyGetter={address => address._id}
             fetchMore={fetchMore}
             render={product => {
               const isChecked = selectedProducts.some(
                 i => productKeyGetter(i) === productKeyGetter(product)
               );
               return (
                 <MobileProductGridCard
                   style={{ flex: 1 }}
                   product={product}
                   priceType={priceType}
                   filters={filters}
                   gridConfig={{ ...grid, pricing: pricingList }}
                   aiSearchActive={aiSearchActive}
                   productPricesLoading={productPricesLoading}
                   searchQuery={searchQuery}
                   checked={isChecked}
                   onProductClick={openProductDetails}
                   onPromotionClick={onPromotionClick}
                   onGetProductPrice={p => onGetProductPrice([p])}
                   checkboxDisabled={() => disableSelect && !isChecked}
                   onStockClick={i =>
                     openProductDetails(i, ProductDetailsTabsIds.WAREHOUSE)
                   }
                   handleCheck={(checked, p) => {
                     handleProductSelect(checked, p);
                   }}
                 />
               );
             }}
           />
           {isLoading && <GridLoader />}
         </>
       )}
       */}
    </ListContainer>
  );
};
